import { IColorHelper } from '../interfaces/color';

export class ColorHelper implements IColorHelper {
  private assetIdColor: Record<string, string> = {};

  constructor() {}

  private generateColor(): string {
    const currentColorsSize = Object.values(this.assetIdColor).length;
    const COLORS = [
      '#1ddd58',
      '#FF0000',
      '#006B6B',
      '#7BA81C',
      '#B500B5',
      '#FF8787',
      '#2E96FF',
      '#FF7A00',
      '#B50000',
      '#223499',
      '#17A68C',
      '#8F8A00',
      '#8A2BE2',
      '#3477DB',
      '#D48364',
      '#800000',
      '#03A0B5',
      '#BC8A0B',
      '#483D8B',
      '#0F6C78',
      '#076DBB',
      '#B8540B',
      '#886288',
    ];

    if (currentColorsSize <= COLORS.length) return COLORS[currentColorsSize];

    const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

    return randomColor;
  }

  setColor(id: string): string {
    if (this.assetIdColor[id]) {
      return this.assetIdColor[id];
    }

    const newColor = this.generateColor();
    this.assetIdColor[id] = newColor;

    return newColor;
  }

  getColor(id: string): string {
    if (this.assetIdColor[id]) {
      return this.assetIdColor[id];
    }

    return '#0f132a';
  }

  removeColor(id: string): void {
    if (!this.assetIdColor[id]) return;

    delete this.assetIdColor[id];
  }

  itemHasColor(id: string): boolean {
    return Boolean(this.assetIdColor[id]);
  }
}
